<template>
  <div ref="chart" :style="{ height: height, width: '100%' }" />
</template>

<script>
import * as echarts from 'echarts';
import { debounce } from 'lodash-es';

/**
 * ECharts基础组件
 * 提供图表初始化、自适应缩放、配置更新等功能
 */
export default {
  name: 'BaseEchart',
  props: {
    options: {
      type: Object,
      required: true, // ECharts配置对象，必传
      description: 'ECharts图表配置项'
    },
    height: {
      type: String,
      default: '300px', // 图表高度，默认300px
      description: '图表容器高度'
    }
  },
  data() {
    return {
      chart: null, // ECharts实例对象
      resizeObserver: null // ResizeObserver实例，用于监听容器大小变化
    };
  },
  watch: {
    // 监听配置项变化，深度监听
    options: {
      handler(val) {
        if (this.chart) {
          // 配置更新时重新设置图表配置，第二个参数true表示不合并
          this.chart.setOption(val, true);
        }
      },
      deep: true // 深度监听对象内部变化
    }
  },
  mounted() {
    // 初始化图表
    this.initChart();

    // 创建防抖的resize处理函数，100ms延迟
    this.resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize(); // 调整图表大小以适应容器
      }
    }, 100);

    // 监听窗口大小变化
    window.addEventListener('resize', this.resizeHandler);

    // 使用ResizeObserver监听容器大小变化（更精确）
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.resizeHandler();
      });
      if (this.$refs.chart) {
        this.resizeObserver.observe(this.$refs.chart);
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前清理资源
    if (this.chart) {
      this.chart.dispose(); // 销毁图表实例，释放内存
      this.chart = null;
    }
    // 移除窗口resize监听
    window.removeEventListener('resize', this.resizeHandler);
    // 断开ResizeObserver监听
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    /**
     * 初始化ECharts图表实例
     * 创建图表实例并应用初始配置
     */
    initChart() {
      if (this.$refs.chart) {
        this.chart = echarts.init(this.$refs.chart);
        this.chart.setOption(this.options);
      }
    }
    // resizeHandler 在 mounted 中定义为防抖函数
  }
};
</script>
